import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getServiceRegions } from "actions/region";
import { getSearchParameter } from "components/Shared/Functions";
import { ServiceTypeEnum } from "typeConstants/ServiceTypeEnum";
import { SERVICE_REGION_EDIT } from "typeConstants/rights";
import { userHasRight } from "selectors/rights";
import { MGrid, MSplitter } from "components/Shared";
import { ACTION_ADD } from "components/Shared/MGrid.tsx";
import ServiceRegionDetails from "components/ServiceRegions/ServiceRegionDetails";

const ServiceRegionList = props => {
  const [selectedServiceRegionIndex, setSelectedServiceRegionIndex] = useState(null);
  const [creatingNewServiceRegion, setCreatingNewServiceRegion] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    getServiceRegions();
    return () => mounted.current = false;
  }, []);

  const getServiceRegions = () => props.getServiceRegions(getSearchParameter(props.location) ?? "");

  const onRegionSelected = i => setSelectedServiceRegionIndex(i);
  const onClose = () => {
    setSelectedServiceRegionIndex(null);
    setCreatingNewServiceRegion(false);
  };

  const onCreateServiceRegion = () => {
    setCreatingNewServiceRegion(true);
  };

  const columns = [
    { key: "msa", name: "Name", dataSource: "name", },
  ];

  const actions = props.canEdit ? [
      { code: ACTION_ADD, onClick: onCreateServiceRegion, tooltip: "Create New MSA" }
    ] : null;

  return (
    <MSplitter
      firstChild={
        <div className="padding-page-content full-height">
          <MGrid
            configurationId="ServiceRegions"
            headerText="MSAs"
            columnDefinitions={columns}
            data={props.serviceRegions}
            isFetchingData={props.isFetchingServiceRegions}
            onRowClick={onRegionSelected}
            displayNumOfItemsFound
            rowLastClicked={selectedServiceRegionIndex}
            actions={actions}
          />
        </div>
      }
      secondChildTitle={{
        title: "MSA Details",
        buttons: [
          { icon: "close", onClick: onClose }
        ]
      }}
      secondChild={(selectedServiceRegionIndex !== null || creatingNewServiceRegion) &&
        <ServiceRegionDetails
          selectedServiceRegionId={props.serviceRegions[selectedServiceRegionIndex]?.id}
          selectedServiceRegionName={props.serviceRegions[selectedServiceRegionIndex]?.name}
          closePanel={onClose}
          refreshServiceRegions={getServiceRegions}
        />
      }
    />
  );
};

ServiceRegionList.propTypes = {
  // Redux
  canEdit: PropTypes.bool,
  getServiceRegions: PropTypes.func.isRequired,
  isFetchingServiceRegions: PropTypes.bool.isRequired,
  serviceRegions: PropTypes.array.isRequired,
};

export default connect(
  state => ({
    isFetchingServiceRegions: state.region.isFetchingServiceRegions,
    serviceRegions: state.region.serviceRegions,
    canEdit: userHasRight(SERVICE_REGION_EDIT)(state),
  }), 
  dispatch => ({
    getServiceRegions(searchTerm) {
      dispatch(getServiceRegions(ServiceTypeEnum.Inspector, searchTerm));
    },
  })
)(ServiceRegionList);